export default "__VITE_ASSET__B$U9U$MF__"